import {Card, Tabs, Typography} from "antd";
import MessageCodeHelp from "./ErrorCodesHelp";
import BaseLayout from "./layout/layout-with-sider/BaseLayout";
import {useUser} from "../Context/UserContext";
import YoutubeComponent from "./YoutubeComponent";
import Tutorial from "./Tutorial";
import {useEffect, useState} from "react";
import ResultTable from "./Table/ResultTable";
import ResultHeader from "./Table/ResultHeader";
import ResultBody from "./Table/ResultBody";
import ResultRow from "./Table/ResultRow";
import ResultHeaderCell from "./Table/ResultHeaderCell";
import CapabilitiesData from "./CapabilitiesData";
import './capabilities-data.css'
import {CheckOutlined} from "@ant-design/icons";
import ApiService from "../Service/ApiService";
import {useProject} from "../Context/ProjectContext";

export function HelpPage()
{
    const {user} = useUser()
    const params = new URLSearchParams(window.location.search)
    const [version, setVersion] = useState('')

    const getVersion = async () => {
        const res = await ApiService.RasCheck.GetVersion();
        if(res.success) {
            setVersion(res.data)
        }
    }

    useEffect(() => {
        getVersion()
    }, [])

    const renderSpecs = (value) => {
        if(value.toString() === 'true') {
            return (
                <div style={{marginLeft: 8, display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                    <CheckOutlined />
                </div>
            )
        }
        else if(value.toString() === 'false') {
            return ''
        }
        else {
            return value
        }
    }

    return (
        <>
            <BaseLayout>
                <Card>
                    <div style={{backgroundColor: '#fff', padding: 8}}>
                        <Tabs tabPosition={'top'} size={'small'} defaultActiveKey={params.get('type') || 'tutorial'}>
                            <Tabs.TabPane tab={'Tutorial'} key={'tutorial'}>
                                <Tutorial />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={'Output File'} key={'output'}>
                                <Typography.Title level={3}>
                                    How to Prepare the Output text file?
                                </Typography.Title>
                                <YoutubeComponent
                                    width={640}
                                    height={360}
                                    speed={1.5}
                                    src={'https://www.youtube.com/embed/ROzov7XibQ0'}
                                />

                                <p>
                                    Since HEC-RAS output files are in ASCII format, an output text file must be prepared by the user to upload together with the input files. This file is created by copying values from the Summary Output Table from HEC-RAS. The output file must contain the following variables without any particular order. Please make sure to select all the plans and profiles for the output table and copy Data and Headings into a text file named as output.txt. The output.txt file must be included in the project folder to upload.
                                </p>
                                <ul>
                                    <li>Prof Delta WS</li>
                                    <li>Sta W.S. Lft</li>
                                    <li>Sta W.S. Rgt</li>
                                    <li>W.S. Elev</li>
                                    <li>Crit W.S.</li>
                                    <li>Vel Head</li>
                                    <li>Conv. Ratio</li>
                                    <li>Headloss</li>
                                    <li>Mann Wtd Chnl</li>
                                    <li>Mann Wtd Left</li>
                                    <li>Mann Wtd Rght</li>
                                </ul>
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={'Capabilities'} key={'Capabilities'}>
                                <table>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td className={'cb-title-text'}>RAS Review {version}</td>
                                        <td className={'cb-title-text'}>cHECk-RAS 2.0.1</td>
                                    </tr>
                                    <tr>
                                        <td rowSpan={55} className={'cb-title'}>
                                            {CapabilitiesData[0].title}
                                        </td>
                                    </tr>
                                    {
                                        CapabilitiesData[0].fields.map(f => (
                                            <>
                                                <tr>
                                                    <td colSpan={3} className={'cb-field-title'}>
                                                        {f.title}
                                                    </td>
                                                </tr>
                                                {
                                                    f.specs.map(s => (
                                                        <tr>
                                                            <td className={'cb-specs-text'}>{s.text}</td>
                                                            <td className={'cb-specs-rascheck'}>{renderSpecs(s.rasReview)}</td>
                                                            <td className={'cb-specs-checkras'}>{renderSpecs(s.checkRas)}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </>
                                        ))
                                    }
                                    <tr>
                                        <td colSpan={3} style={{height: 8}}></td>
                                    </tr>

                                    <tr>
                                        <td rowSpan={25} className={'cb-title'}>
                                            {CapabilitiesData[1].title}
                                        </td>
                                    </tr>
                                    {
                                        CapabilitiesData[1].fields.map(f => (
                                            <>
                                                <tr>
                                                    <td colSpan={3} className={'cb-field-title'}>
                                                        {f.title}
                                                    </td>
                                                </tr>
                                                {
                                                    f.specs.map(s => (
                                                        <tr>
                                                            <td className={'cb-specs-text'}>{s.text}</td>
                                                            <td className={'cb-specs-rascheck'}>{renderSpecs(s.rasReview)}</td>
                                                            <td className={'cb-specs-checkras'}>{renderSpecs(s.checkRas)}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </>
                                        ))
                                    }
                                    <tr>
                                        <td colSpan={3} style={{height: 8}}></td>
                                    </tr>

                                    <tr>
                                        <td rowSpan={19} className={'cb-title'}>
                                            {CapabilitiesData[2].title}
                                        </td>
                                    </tr>
                                    {
                                        CapabilitiesData[2].fields.map(f => (
                                            <>
                                                <tr>
                                                    <td colSpan={3} className={'cb-field-title'}>
                                                        {f.title}
                                                    </td>
                                                </tr>
                                                {
                                                    f.specs.map(s => (
                                                        <tr>
                                                            <td className={'cb-specs-text'}>{s.text}</td>
                                                            <td className={'cb-specs-rascheck'}>{renderSpecs(s.rasReview)}</td>
                                                            <td className={'cb-specs-checkras'}>{renderSpecs(s.checkRas)}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </>
                                        ))
                                    }
                                </table>
                            </Tabs.TabPane>
                            {
                                user?.data?.isAdmin && (
                                    <Tabs.TabPane tab={'Messages'} key={'error-codes'}>
                                        <MessageCodeHelp />
                                    </Tabs.TabPane>
                                )
                            }
                        </Tabs>
                    </div>
                </Card>
            </BaseLayout>
        </>
    )
}